// extracted by mini-css-extract-plugin
var _1 = "#000";
var _2 = "#c90000";
var _3 = "diff1Fill-bkMi";
var _4 = "#65c300";
var _5 = "diff2Fill-fRPb";
export { _1 as "commonColor", _2 as "diff1Color", _3 as "diff1Fill", _4 as "diff2Color", _5 as "diff2Fill" }
